/**
 * @generated SignedSource<<ab0a47cef46d9cf31cd378a8dfc30923>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PageSettings_page$data = {
  readonly id: string;
  readonly image: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"PageSettingsDeleteButton_image">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"TextControl_widgetNotePage" | "WidgetNotePageBackgroundSelector_widgetNotePage">;
  readonly " $fragmentType": "PageSettings_page";
};
export type PageSettings_page$key = {
  readonly " $data"?: PageSettings_page$data;
  readonly " $fragmentSpreads": FragmentRefs<"PageSettings_page">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageSettings_page",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PageSettingsDeleteButton_image"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TextControl_widgetNotePage"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetNotePageBackgroundSelector_widgetNotePage"
    }
  ],
  "type": "WidgetNotePage",
  "abstractKey": null
};
})();

(node as any).hash = "822f2aad34a12441e2570909060384a7";

export default node;
